export default __webpack_public_path__ + "static/media/Java.35e27dc0.svg";